import { motion } from "framer-motion"
import styled from "@emotion/styled"

const BadgeContainer = styled(motion.div)`
  position: absolute;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #ff3366, #ff9933);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.9rem;
  z-index: 10;
  box-shadow: 0 4px 15px rgba(255, 51, 102, 0.3);
  overflow: hidden;
`

const BadgeContent = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Target = styled(motion.span)`
  display: inline-block;
  margin-left: 5px;
`

const Sparkle = styled(motion.div)`
  position: absolute;
  background: white;
  width: 3px;
  height: 3px;
  border-radius: 50%;
`

export function AnimatedBadge({text}) {
  const badgeVariants = {
    initial: { scale: 0.8, opacity: 0 },
    animate: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 260,
        damping: 20,
      },
    },
    hover: {
      scale: 1.05,
      boxShadow: "0 6px 20px rgba(255, 51, 102, 0.4)",
      transition: { duration: 0.3 },
    },
  }

  const contentVariants = {
    initial: { y: 20, opacity: 0 },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.2,
        type: "spring",
        stiffness: 260,
        damping: 20,
      },
    },
  }

  const targetVariants = {
    initial: { rotate: -45, scale: 0 },
    animate: {
      rotate: 0,
      scale: 1,
      transition: {
        delay: 0.5,
        type: "spring",
        stiffness: 260,
        damping: 20,
      },
    },
  }

  const sparkleVariants = {
    initial: { scale: 0, opacity: 1 },
    animate: {
      scale: [0, 1, 0],
      opacity: [1, 1, 0],
      transition: {
        repeat: Number.POSITIVE_INFINITY,
        repeatDelay: 2,
        duration: 1,
      },
    },
  }

  return (
    <BadgeContainer variants={badgeVariants} initial="initial" animate="animate" whileHover="hover">
      <BadgeContent variants={contentVariants}>
          {text}
      </BadgeContent>
      {[...Array(5)].map((_, i) => (
        <Sparkle
          key={i}
          variants={sparkleVariants}
          style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
          }}
        />
      ))}
    </BadgeContainer>
  )
}

